import { render } from "./student-quiz-details.vue?vue&type=template&id=7d013116"
import script from "./student-quiz-details.vue?vue&type=script&lang=js"
export * from "./student-quiz-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__